import { ThemeOverrideProvider } from "@commonlibs";
import useAppBarState from "../hook/useAppBarState";

export interface AppHeaderThemeProviderProps {
    children: React.ReactNode;
}

function AppHeaderThemeProvider({ children }: AppHeaderThemeProviderProps) {
    const [{ activeBg }] = useAppBarState();
    return (
        <ThemeOverrideProvider
            overrides={(theme) => {
                const palette = theme.palette;
                return {
                    ...theme,
                    palette: {
                        ...palette,
                        ...(activeBg && {
                            primary: palette.background,
                            text: palette.white,
                            background: palette.primary,
                        }),
                    },
                };
            }}
        >
            {children}
        </ThemeOverrideProvider>
    );
}

export default AppHeaderThemeProvider;
